import React, { useState } from 'react';
import { IAppProps } from '@interfaces/App.interface';
import { Grid, Typography } from '@ts/storybook';
import KPI from '@components/KPI';
import { appPalette } from '@public/customization/CustomTheme';

interface DashboardProps extends IAppProps {}

const DashboardMockPage = (props: DashboardProps) => {
  const [value, setValue] = useState('today');
  const [slot, setSlot] = useState('week');

  const firstColor = appPalette.primary;
  const lastColor = '#077bc0';

  //#region Handlers
  const onChangeSlot = (item: any, type: string) => {
    setSlot(type);
  };
  //#endregion

  //#region MockData
  const data1 = {
    xaxis: {
      categories: ['Archirodon', 'Contractor A', 'Contractor B', 'Contractor C', 'Inspector Services Co', 'Port de Laayoune'],
    },
    series: [
      {
        name: 'PERSONNEL BY COMPANY',
        data: [73, 4, 146, 255, 2, 6],
      },
    ],
  };
  const data2 = {
    xaxis: {
      categories: ['Managers', 'EHS', 'OtherStaff', 'Contractors', 'Lone Workers', 'Others'],
    },
    series: [
      {
        name: 'PERSONNEL ON SITE BY CATEGORY',
        data: [8, 4, 6, 230, 64, 45],
      },
    ],
  };

  const data3 = {
    xaxis: {
      categories: ['Help button', 'Impact', 'In risk zones', 'No link', 'No movement', 'Battery <10%', 'Out of perimeter'],
    },
    series: [
      {
        name: 'HSE Events',
        data: [3, 4, 26, 5, 12, 10, 2],
      },
    ],
  };

  const dataTime1 = {
    series: [
      {
        name: 'Archirodon TEAM 3',
        data: [
          {
            x: 'Subproject 3452-DWE',
            y: [new Date('2019-03-05').getTime(), new Date('2019-03-08').getTime()],
          },
          {
            x: 'Subproject 3452-AA',
            y: [new Date('2019-03-02').getTime(), new Date('2019-03-05').getTime()],
          },
          {
            x: 'Subproject 3452-AA',
            y: [new Date('2019-03-05').getTime(), new Date('2019-03-07').getTime()],
          },
          {
            x: 'Subproject 556',
            y: [new Date('2019-03-03').getTime(), new Date('2019-03-09').getTime()],
          },
          {
            x: 'Subproject 556-Bis',
            y: [new Date('2019-03-08').getTime(), new Date('2019-03-11').getTime()],
          },
          {
            x: 'Subproject 42-B',
            y: [new Date('2019-03-11').getTime(), new Date('2019-03-16').getTime()],
          },
          {
            x: 'Subproject 3452-DWE',
            y: [new Date('2019-03-01').getTime(), new Date('2019-03-03').getTime()],
          },
        ],
      },
      {
        name: 'Contractor Company B',
        data: [
          {
            x: 'Subproject 3452-DWE',
            y: [new Date('2019-03-02').getTime(), new Date('2019-03-05').getTime()],
          },
          {
            x: 'Subproject 556-Bis',
            y: [new Date('2019-03-06').getTime(), new Date('2019-03-16').getTime()],
            goals: [
              {
                name: 'Task  422',
                value: new Date('2019-03-10').getTime(),
                strokeColor: '#CD2F2A',
              },
            ],
          },
          {
            x: 'Subproject 3452-AA',
            y: [new Date('2019-03-03').getTime(), new Date('2019-03-07').getTime()],
          },
          {
            x: 'Training and certificications',
            y: [new Date('2019-03-20').getTime(), new Date('2019-03-22').getTime()],
          },
          {
            x: 'Subproject 3452-DWE',
            y: [new Date('2019-03-10').getTime(), new Date('2019-03-16').getTime()],
          },
        ],
      },
      {
        name: 'Contractor Company B',
        data: [
          {
            x: 'Subproject 3452-AA',
            y: [new Date('2019-03-10').getTime(), new Date('2019-03-17').getTime()],
          },
          {
            x: 'Subproject 42-B',
            y: [new Date('2019-03-05').getTime(), new Date('2019-03-09').getTime()],
            goals: [
              {
                name: 'Task  422',
                value: new Date('2019-03-07').getTime(),
                strokeColor: '#CD2F2A',
              },
            ],
          },
        ],
      },
    ],
  };
  const dataTime2 = {
    series: [
      {
        name: 'Archirodon TEAM 3',
        data: [
          {
            x: 'Road Km 22-23',
            y: [new Date('2019-03-05').getTime(), new Date('2019-03-08').getTime()],
          },
          {
            x: 'Road Km 67- 67,300',
            y: [new Date('2019-03-02').getTime(), new Date('2019-03-05').getTime()],
          },
          {
            x: 'Road Km 68- 68,100',
            y: [new Date('2019-03-05').getTime(), new Date('2019-03-07').getTime()],
          },
          {
            x: 'Road Km 68',
            y: [new Date('2019-03-03').getTime(), new Date('2019-03-09').getTime()],
          },
          {
            x: 'Road Km 69',
            y: [new Date('2019-03-08').getTime(), new Date('2019-03-11').getTime()],
          },
          {
            x: 'Road Km 69,100',
            y: [new Date('2019-03-11').getTime(), new Date('2019-03-16').getTime()],
          },
          {
            x: 'Road Km 22-23',
            y: [new Date('2019-03-01').getTime(), new Date('2019-03-03').getTime()],
          },
        ],
      },
      {
        name: 'Contractor Company B',
        data: [
          {
            x: 'Road Km 22-23',
            y: [new Date('2019-03-02').getTime(), new Date('2019-03-05').getTime()],
          },
          {
            x: 'Road Km 69',
            y: [new Date('2019-03-06').getTime(), new Date('2019-03-16').getTime()],
            goals: [
              {
                name: 'Task  422',
                value: new Date('2019-03-10').getTime(),
                strokeColor: '#CD2F2A',
              },
            ],
          },
          {
            x: 'Road Km 67- 67,300',
            y: [new Date('2019-03-03').getTime(), new Date('2019-03-07').getTime()],
          },
          {
            x: 'Others',
            y: [new Date('2019-03-20').getTime(), new Date('2019-03-22').getTime()],
          },
          {
            x: 'Road Km 22-23',
            y: [new Date('2019-03-10').getTime(), new Date('2019-03-16').getTime()],
          },
        ],
      },
      {
        name: 'Contractor Company B',
        data: [
          {
            x: 'Road Km 67- 67,300',
            y: [new Date('2019-03-10').getTime(), new Date('2019-03-17').getTime()],
          },
          {
            x: 'Road Km 69,100',
            y: [new Date('2019-03-05').getTime(), new Date('2019-03-09').getTime()],
            goals: [
              {
                name: 'Task  422',
                value: new Date('2019-03-07').getTime(),
                strokeColor: '#CD2F2A',
              },
            ],
          },
        ],
      },
    ],
  };

  //#endregion

  return (
    <Grid container size={12} spacing={3} p={4}>
      {/* row 1 */}
      {/* <Grid size={{xs:12}} sx={{ mb: -2.25 }}>
        <Typography variant="h5">Dashboard</Typography>
      </Grid> */}
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Personnel on site" dataCard={{ value: 980, oldValue: 970 }} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="In risk area" dataCard={{ value: 14, oldValue: 17 }} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Alerts open" dataCard={{ value: 21, oldValue: 32 }} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Notifications in 24h" dataCard={{ value: 5, oldValue: 5 }} />
      </Grid>

      {/* row 2 */}
      <Grid size={{ xs: 12, md: 4 }}>
        <KPI.PieChart
          {...props}
          title={'Alerts by severity'}
          dataChart={{
            labels: [],
            series: [{ name: 'string', data: [] }],
          }}
          loading={false}
          isMock
        />
      </Grid>
      <Grid size={{ xs: 12, md: 8 }}>
        <KPI.BarChart options={{ color: '#ff0003', title: 'HSE - Risk events', height: 500 }} dataChart={data3} loading={false} />
      </Grid>

      {/* row 3 */}
      <Grid size={{ xs: 12 }}>
        <KPI.MainCard content={false}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid ml={2} mt={2}>
              <Typography variant="h5" color="primary" className="font-medium" text="Worker in risk" />
            </Grid>
            <Grid />
          </Grid>
          <KPI.TasksTable isInRisk />
        </KPI.MainCard>
      </Grid>

      {/* row 4 */}
      <Grid size={{ xs: 12 }}>
        <KPI.BarChart
          {...props}
          options={{ color: '#0a8103', title: 'Personnel by company' }}
          dataChart={data1}
          loading={false}
        />
      </Grid>
    </Grid>
  );
};

export default DashboardMockPage;
